import { PLANS, PRO_FEATURES } from '../content';
import { CheckIcon } from '../icons';

export function Pricing() {
  return (
    <section className="section hairline-t" id="pricing">
      <div className="container">
        <div style={{ textAlign: 'center', maxWidth: 620, margin: '0 auto 56px' }}>
          <div className="eyebrow" style={{ marginBottom: 18 }}>
            Cranio Pro
          </div>
          <h2 className="h-title">The full studio, unlocked.</h2>
          <p className="h-sub" style={{ margin: '18px auto 0' }}>
            Study free with the planar head. Go Pro for every model, all finishes, pro lighting
            rigs and 4K export.
          </p>
        </div>
        <div
          className="pricing-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 16,
            maxWidth: 960,
            margin: '0 auto',
          }}
        >
          {PLANS.map((p) => (
            <div
              key={p.id}
              style={{
                position: 'relative',
                borderRadius: 6,
                padding: '30px 26px 26px',
                background: p.best ? 'var(--bg-3)' : 'var(--bg-2)',
                border: p.best ? '0.5px solid var(--line-3)' : '0.5px solid var(--line-1)',
                boxShadow: p.best ? '0 30px 60px rgba(0,0,0,0.45)' : 'none',
              }}
            >
              {p.badge && (
                <span
                  className="mono"
                  style={{
                    position: 'absolute',
                    top: 22,
                    right: 22,
                    fontSize: 9,
                    fontWeight: 600,
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    color: 'var(--bg-1)',
                    background: 'var(--fg-1)',
                    borderRadius: 4,
                    padding: '3px 7px',
                  }}
                >
                  {p.badge}
                </span>
              )}
              <div style={{ fontSize: 16, fontWeight: 600, letterSpacing: '-0.01em' }}>{p.name}</div>
              <div className="mono" style={{ fontSize: 10.5, color: 'var(--fg-3)', marginTop: 4 }}>
                {p.sub}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 6,
                  margin: '26px 0 22px',
                }}
              >
                <span
                  className="tnum"
                  style={{ fontSize: 38, fontWeight: 600, letterSpacing: '-0.04em' }}
                >
                  {p.price}
                </span>
                <span className="mono" style={{ fontSize: 12, color: 'var(--fg-3)' }}>
                  {p.period}
                </span>
              </div>
              <a
                className={`btn ${p.best ? 'btn-solid' : 'btn-ghost'}`}
                href="#download"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                {p.cta}
              </a>
              <div
                className="mono"
                style={{
                  fontSize: 9.5,
                  color: 'var(--fg-4)',
                  textAlign: 'center',
                  marginTop: 12,
                  lineHeight: 1.5,
                }}
              >
                {p.fine}
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '14px 28px',
            marginTop: 44,
          }}
        >
          {PRO_FEATURES.map((x) => (
            <span
              key={x}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 9,
                fontSize: 13,
                color: 'var(--fg-2)',
              }}
            >
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  border: '0.5px solid var(--line-2)',
                  color: 'var(--fg-1)',
                }}
              >
                <CheckIcon />
              </span>
              {x}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
